// The native app build (Cordova) and its platform, or undefined for the website. REACT_APP_NATIVE is
// set by bin/build-android.sh / bin/build-ios.sh. A build-time constant, so app-only code is dropped
// from the web bundle.
export const nativePlatform = process.env.REACT_APP_NATIVE as 'android' | 'ios' | undefined;
export const isNativeApp = !!nativePlatform;
